import { gql } from "urql";
export const SendPriorityPublicInviteMutation = gql `
    mutation SendPriorityPublicInvite($email: String!, $note: String) {
        priorityInvites {
            createPriorityInvite(email: $email, note: $note) {
                email
                inviteUrl
            }
        }
    }
`;
export const ResendPriorityInviteMutation = gql `
    mutation ResendPriorityInvite($priorityInviteId: String!) {
        priorityInvites {
            resendPriorityInvite(priorityInviteId: $priorityInviteId) {
                success
            }
        }
    }
`;
export const DeletePriorityInviteMutation = gql `
    mutation DeletePriorityInvite($inviteId: String!) {
        priorityInvites {
            deletePriorityInvite(inviteId: $inviteId) {
                priorityInviteId
            }
        }
    }
`;
